




























































































































import { Component, Prop, Vue } from 'vue-property-decorator';

interface CartItem {
    name: string,
    value: string,
}

@Component({
    name: 'Cart',
})
export default class Cart extends Vue {

    @Prop({required: true}) protected cartData!: CartItem[];
    @Prop({required: true}) protected shouldVATNotificationShow!: boolean;

    protected get cartSummary() {
        return this.$store.getters['user/cartSummary'];
    }

    protected get isCartEmpty() {
        if (this.cartSummary.data.attributes.amountOfAlreadyPurchasedItems == null &&
            this.cartSummary.data.attributes.amountOfFullPriceItems == null &&
            this.cartSummary.data.attributes.amountOfHalfPriceItems == null) {
            return true;
        }
        return this.cartSummary.data.attributes.amountOfAlreadyPurchasedItems === 0 &&
            this.cartSummary.data.attributes.amountOfFullPriceItems === 0 &&
            this.cartSummary.data.attributes.amountOfHalfPriceItems === 0;
    }

    protected rowClassHandler(rowData: { row: CartItem, rowIndex: number }) {
        return rowData.row.name === 'Total' || rowData.row.name === 'Total records remaining' ? 'is-total' : '';
    }

    protected calculateOne(first: number, second: number) {
        if (first) {
            return 'à $' + (first / second);
        } else {
            return '-';
        }
    }

    protected formatOutput(text: string) {
        if (text) {
            return '$' + parseFloat(text).toFixed(2);
        } else {
            return '';
        }
    }

}
